(function($) {

    var hes = {
        init: function() {
            this.slickSlide();
        },

        slickSlide:function() {
            $('.tour-slick').slick({
                dots: true,
                focusOnSelect: false,
                arrows: false
            })
        }
    }

    $(document).ready( ()=> {
		hes.init();
	})
})(jQuery)